// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3R8kC","buttons":"Footer_buttons__1pFrH"};